import { useUserOptional } from "@/components/auth-provider";
import { useRouter } from "@/hooks/use-router-compat";
import { usePathname } from "@/hooks/use-pathname-compat";
import { useEffect } from "react";

// Routes accessible without a company (parameters page with profile/company options)
const ALLOWED_WITHOUT_COMPANY = ["/parameters", "/profile", "/company"];

function isAllowedWithoutCompany(pathname: string): boolean {
  return ALLOWED_WITHOUT_COMPANY.some(
    (route) => pathname === route || pathname.startsWith(route + "/"),
  );
}

export function CompanyCheck({ children }: { children: React.ReactNode }) {
  const user = useUserOptional();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (user && !user.company_id && !isAllowedWithoutCompany(pathname)) {
      router.push("/company");
    }
  }, [user, pathname, router]);

  if (user && !user.company_id && !isAllowedWithoutCompany(pathname)) {
    return null;
  }

  return <>{children}</>;
}
